<template>
  <div class="language-setting">
    <vh-radio-group v-model="currentLang">
      <vh-radio-card label="zh">简体中文</vh-radio-card>
      <vh-radio-card label="en">English</vh-radio-card>
    </vh-radio-group>
  </div>
</template>
<script>
  import { reloadCurrentPage } from '@/app-shared/utils/common';
  export default {
    name: 'LangSwitcher',
    data() {
      return {
        currentLang: 'zh'
      };
    },
    created() {
      const localUserLang = localStorage.getItem('user-lang');
      this.currentLang = ['zh', 'en'].includes(localUserLang) ? localUserLang : 'zh';
    },
    methods: {
      // 语言切换保存，在文件src/packages/media-setting/src/main.vue中点击“保存"按钮时，通过ref调用
      save() {
        if (this.$i18n.locale !== this.currentLang) {
          // this.$i18n.locale = this.currentLang; // 切换语言
          // 设置语言
          localStorage.setItem('user-lang', this.currentLang); // 持久化存储
          // 刷新
          reloadCurrentPage();
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .language-setting {
    margin-top: 14px;
  }
</style>
